import React from 'react';
import Footer from './Footer';
import Header from './Header';
import { Helmet } from 'react-helmet';

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kratos Gas &amp; Power Ohio | Natural Gas Company Ohio</title>

        <meta
          name="description"
          content="Kratos Gas &amp; Power is a natural gas company for Ohio. Our natural gas experts are committed to providing your home or business with excellent service."
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link rel="canonical" href="https://ohio.kratosgp.com/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Kratos Gas &amp; Power Ohio | Natural Gas Company Ohio"
        />
        <meta
          property="og:description"
          content="Kratos Gas &amp; Power is a natural gas company for Ohio. Our natural gas experts are committed to providing your home or business with excellent service."
        />
        <meta property="og:url" content="https://ohio.kratosgp.com/" />
        <meta property="og:site_name" content="Kratos Gas &amp; Power Ohio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          content="Kratos Gas &amp; Power is a natural gas company for Ohio. Our natural gas experts are committed to providing your home or business with excellent service."
        />
        <meta
          name="twitter:title"
          content="Kratos Gas &amp; Power Ohio | Natural Gas Company Ohio"
        />
        <meta name="facebook-domain-verification" content="5b41f4enw35ff9sf4zkk2uhqyr2axk" />
        <link
          rel="icon"
          type="image/png"
          href="https://imgix.cosmicjs.com/672f0a90-c69e-11ea-8fc2-8d973b3e3b71-kratosfavicon.png"
        />
      </Helmet>
      <Header />
      <main className="text-gray-900">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
